module.exports = __webpack_public_path__ + "manageStatic/img/player-bg.f412d651.png";